export interface IProfile {
    id?: number;
    displayName: string;
    avatar: number;
    type: number;
    rating: number;
    spendLimit: number;
    language: string;
    pinEnabled?: boolean;
    pin?: string;
    getParental?(val: number): any;
    getLimits?(val: number): any;
}

export class Profile {

    constructor() { }

    // Return the available parental ratings
    getParental(selection) {
        let ratings = [{
            id: 0,
            title: "K",
            checked: true
        }, {
            id: 1,
            title: "8",
            checked: false
        }, {
            id: 2,
            title: "12",
            checked: false
        }, {
            id: 3,
            title: "16",
            checked: false
        }, {
            id: 4,
            title: "18",
            checked: false
        }];

        ratings.forEach(obj => {
            obj.checked = obj.id == selection;
        });

        return ratings;
    }

    // Return the available parental ratings
    getLimits(selection) {
        let limits = [{
            id: 0,
            title: "gen_no_limit",
            checked: true
        }, {
            id: 1,
            title: "€10",
            checked: false
        }, {
            id: 2,
            title: "€20",
            checked: false
        }, {
            id: 3,
            title: "€30",
            checked: false
        }, {
            id: 4,
            title: "€40",
            checked: false
        }];

        limits.forEach(obj => {
            obj.checked = obj.id == selection;
        });

        return limits;
    }

    // Returns the available profiles
    getAvatars() {
        return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
    }

    // Returns the available profile types
    getTypes() {
        return [1, 2];
    }
}